import { Type } from "@angular/core";
import { BalanceByActivityChartComponent } from "./charts/balanceByActivityChart.component";
import { ExpenditureChartComponent } from "./charts/expenditureChart.component";
import { RevenueChartComponent } from "./charts/revenueChart.component";
export const SA_CHART_COMPONENTS: Record<string, Type<unknown>> = {
    "StudentActivities.BalanceByActivityChart": BalanceByActivityChartComponent,
    "StudentActivities.MonthlyExpenditureChart": ExpenditureChartComponent,
    "StudentActivities.MonthlyRevenueChart": RevenueChartComponent,
};
